import Popover from 'antd/es/popover';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { messageData } from '../../helpers/Dialogs';
import { getCommonRoutePath } from '../../helpers/Helpers';
dayjs.extend(calendar);

export default function DialogFooter({
    dialog,
    children,
    handleSurePopupClick,
    activeUsers,
    isNotAllowedToChat,
    timeLimitReached,
    isAllowedToReopen,
    isMobile,
    isProspect,
}) {
    if (dialog.isProspectBlocked && !dialog.isMyAccountBlocked) {
        return (
            <div className="chat-footer mod-closed">
                <p className="closed-text">
                    Admin blocked prospect {dialog.prospect.name}. All their messages were hidden.
                </p>
            </div>
        );
    } else if (dialog.isMyAccountBlocked) {
        return (
            <div className="chat-footer mod-closed">
                <p className="closed-text">
                    Your account <span className="blocked-text">was blocked from chatting</span> with ambassadors{' '}
                </p>
            </div>
        );
    } else if (isNotAllowedToChat) {
        if (timeLimitReached) {
            return (
                <div className="chat-footer mod-closed">
                    <p className="closed-text">
                        You have now reached your time limit and your profile has been deactivated. It will
                        automatically reactivate in the next time period. Please contact your Admin if you have any
                        questions.
                    </p>
                </div>
            );
        } else {
            return (
                <div className="chat-footer mod-closed">
                    {dialog.type === 1 ? (
                        <p className="closed-text">
                            Sorry, your profile has been deactivated for Chat. Please contact your Admin if you have any
                            questions.
                        </p>
                    ) : (
                        <p className="closed-text">
                            Sorry, your profile has been deactivated for Chat so you're unable to access the Group Chat.
                            Please contact your Admin if you have any questions.
                        </p>
                    )}
                </div>
            );
        }
    } else if (dialog.admin_closed) {
        if (dialog.type === 1) {
            return isAllowedToReopen ? (
                <div
                    className="chat-footer mod-closed"
                    onClick={() => {
                        handleSurePopupClick('handleReopenDialog');
                    }}
                >
                    <p className="closed-text">Admin closed this conversation</p>
                    <button type="button" className="reopen-btn">
                        Reopen
                    </button>
                </div>
            ) : (
                <div className="chat-footer mod-closed">
                    <p className="closed-text">
                        This prospect account has been deleted, so you are unable to re-open the conversation
                    </p>
                </div>
            );
        } else {
            return (
                <div className="chat-footer mod-closed">
                    <p className="closed-text">
                        Thank you for getting involved! This Group Chat is now closed. If you still have questions or
                        would like to continue chatting, speak to one of our friendly ambassadors directly.
                    </p>
                </div>
            );
        }
    } else if (dialog.closed && dialog.type === 1) {
        return isAllowedToReopen ? (
            <div
                className="chat-footer mod-closed"
                onClick={() => {
                    handleSurePopupClick('handleReopenDialog');
                }}
            >
                <p className="closed-text">
                    {isProspect
                        ? 'Thank you very much for chatting with us. You can always reopen chat if you have more questions.'
                        : 'This conversation is closed'}
                </p>
                <button type="button" className="reopen-btn">
                    Reopen
                </button>
            </div>
        ) : (
            <div className="chat-footer mod-closed">
                <p className="closed-text">
                    This prospect account has been deleted, so you are unable to re-open the conversation
                </p>
            </div>
        );
    } else if ((dialog.user_reported || dialog.hide_keywords || dialog.reported) && dialog.type === 1) {
        return (
            <div className="chat-footer">
                <p className="chat-footer-flagged">This conversation has been reported</p>
            </div>
        );
    } else if (activeUsers && +activeUsers === 0 && dialog.type === 1) {
        let ambassador = 'Ambassador';
        if (dialog && dialog.members) {
            [ambassador] = dialog.members.filter((item) => {
                return item.role_key === 'univercity-student';
            });
        }
        const commonPath = getCommonRoutePath();

        return (
            <div className="chat-footer mod-closed text-center">
                <div>
                    <span>
                        {(ambassador ? ambassador.name : 'Ambassador') + ' '}is currently not available for replying to
                        chat messages. You may like to direct your question to{' '}
                    </span>
                    <NavLink
                        className="see-more-ambassadors"
                        end
                        to={commonPath + '/chat-to-us'}
                        aria-label="Look for another ambassador"
                    >
                        another ambassador
                    </NavLink>
                </div>
            </div>
        );
    } else if (dialog.isMyMessageReported) {
        const text = {
            type: 'text',
            content: {
                text: dialog.reportedMessage.text,
            },
        };
        return (
            <div className="chat-footer mod-closed">
                <p className="closed-text">
                    Your{' '}
                    <Popover
                        overlayClassName={`report-reason-popover ${isMobile ? 'mobile' : ''}`}
                        trigger={isMobile ? 'click' : 'hover'}
                        placement="bottomLeft"
                        content={
                            <div className="msg-block-item" style={{ marginBottom: 20 }}>
                                <p className="msg-name">
                                    <span className="user-name-brand">{dialog.reportedMessage.user_name}</span>
                                </p>
                                <p className="msg-text">{messageData(text)}</p>
                                <div className="msg-controls" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <p className="msg-time" aria-hidden="true">
                                        {dayjs(dialog.reportedMessage.created_at).calendar(null, {
                                            sameDay: 'H:mm',
                                            nextDay: '[Tomorrow]',
                                            nextWeek: '[Next] dddd',
                                            lastDay: '[Yesterday at ]H:mm',
                                            lastWeek: 'DD MMMM',
                                            sameElse: 'DD MMMM',
                                        })}
                                    </p>
                                </div>
                            </div>
                        }
                    >
                        <span className="report-reason-popover-text">message was reported. </span>
                    </Popover>
                    We need to explore the reason before you continue chatting
                </p>
            </div>
        );
    } else {
        return <div className="chat-footer">{children}</div>;
    }
}
